(function ($) {
  rightForMeFormatterV1 = {
    formatter: $('.right-for-me-formatter-v1')
  };

  Drupal.behaviors.rightForMeFormatterV1 = {
    get: function (key) {
      return rightForMeFormatterV1[key];
    },

    set: function (key, val) {
      rightForMeFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var productItems = thisFormatter.find('.product-item');
        var hotspotContainer = thisFormatter.find('.right-for-me-image');
        var defaultImage = hotspotContainer.attr('data-default-image-path');
        var descriptionContainer = thisFormatter.find('.subtitle');
        var shadeContainer = thisFormatter.find('.shade-container');
        var buttonContainer = thisFormatter.find('.button-container');

        // Add "prod" class to this formatter - DoneDone #210
        if (productItems.hasClass('prod')) {
          thisFormatter.addClass('prod');
          if ($('body').hasClass('page-product')) {
            thisFormatter.removeClass('prod');
          }
        }

        // build object
        var products = [];

        productItems.each(function (i) {
          var image = $(this).find('.product-image');
          var imagePath = image.find('img').attr('src');
          var coordLeft = Math.floor((image.attr('data-coord-left') / 600) * 100);
          var coordTop = Math.floor((image.attr('data-coord-top') / 350) * 100);
          var description = $(this).find('.product-description');
          var shade = $(this).find('.product-shade');
          var button = $(this).find('.product-button');

          products[i] = {
            'product': 'product-' + (i + 1),
            'data': {
              'image': imagePath,
              'left': coordLeft,
              'top': coordTop,
              'description': description,
              'shade': shade,
              'button': button
            }
          };
        });

        // build hotspot
        $.each(products, function (i, val) {
          hotspotContainer.append('<div class="hotspot" product="' + val['product'] + '" style="left:' + val['data']['left'] + '%; top:' + val['data']['top'] + '%;"></div>');
        });

        // when hotspot is clicked
        hotspotContainer.find('.hotspot').on('click', function(e) {
          var item = $(this).attr('product');
          var obj = null;

          $.each(products, function (i, val) {
            if (val['product'] == item) {
              obj = val['data'];
            }
          });

          // add active class
          hotspotContainer.find('.hotspot').removeClass('active');
          $(this).addClass('active');

          // change background image
          hotspotContainer.find('img').attr('src', obj['image']);

          // change description text
          descriptionContainer.empty().append(obj['description']);

          // change shade information
          shadeContainer.empty().append(obj['shade']);

          // Show product description under product name - DoneDone #210
          if (thisFormatter.hasClass('prod')) {
            descriptionContainer.insertAfter(shadeContainer);
          }

          // change add to bag button
          var cartButton = obj['button'];

          cartButton.once().on('click', function(e) {
            e.preventDefault();
            // get sku for 'add to cart'
            var buySkus = [];

            // Handle PRODIDs on "right_for_me_prod_item_v1" template - DoneDone #210
            if (productItems.hasClass('prod')) {
              buySkus = $(this).attr('data-productid');
            } else {
              buySkus = $(this).attr('data-skubaseid');
            }

            // add sku to cart
            site.addToCart({
              skuBaseId: buySkus
            });
          });
          buttonContainer.empty().append(cartButton);
        });
      });
    }
  };
})(jQuery);
